import { store } from '../store/index';
import { getTextWithConditions } from '@mixins/utils/conditions';
import replaceVariables from '@mixins/utils/replace-variables';

/**
 * Get an element from the page data.
 * @param {string} path
 */
export const get = path => {
  return store.getters['page/getFromData'](path);
};

/**
 * Get a value from the page data.
 * @param {string} path
 */
export const getValue = path => {
  return get(path + '.value');
};

/**
 * Get a text from the page data.
 * @param {object} item
 */
export const getFormattedText = item => {
    let text = getTextWithConditions(item);
    text = replaceVariables(text);

    return stringIsNotEmpty(text) ? text : '';
}

/**
 * Get a text from the page data.
 * @param {string} item
 */
export const getText = item => {
  let text = '';

  if (typeof item === 'string') text = get(item);
  else text = text.text;

  if (stringIsEmpty(text)) return '';

  if (stringIsEmpty(text)) return '';
  if (typeof text === 'string') return text.replace(/<\/?[^>]+(>|$)/g, '');

  return text.text.replace(/<\/?[^>]+(>|$)/g, '') || '';
};

/**
 * Check if a string is empty.
 * @param {string} item
 */
export const stringIsEmpty = item => {
  let text = '';

  if (item === null) return true;

  if (typeof item === 'object' && !!item.text) {
    text = item.text;
  } else {
    text = item;
  }

  if (text === null) return true;
  if (typeof text !== 'string') return false;

  const array = text.split('<');

  /*
   * We use 4 because when we explode the string, if it's a single empty break,
   * so for example, <p class="break-parent-hidden"><br class="break-hidden"></p>,
   * it will never return more than 4 items in the array.
   *
   * This is because it counts the 3 '<' characters the string contains, and the explode()
   * function returns an empty value as first item because the separator is the first
   * character of the string and a blank string value is a valid value.
  */
  if (array.length <= 4) {
    let parentHidden = false;
    for (const item of array) {
      if (item.includes('break-parent-hidden')) {
        parentHidden = true;
        continue;
      }

      if (parentHidden && item.includes('break-hidden')) {
        return true;
      }
    }
  }

  return false;
};

/**
 * Check if a string is not empty.
 * @param {string} item
 */
export const stringIsNotEmpty = item => {
  return !stringIsEmpty(item);
};

/**
 * Check if a media is empty.
 * @param {string} item
 */
export const mediaIsEmpty = item => {
  if (typeof item === 'object' && item['video'] !== '' && item['video'] !== null) {
    return item['video'] === '//';
  }

  if (typeof item === 'string' && item !== '' && item !== null) {
    return item === '//';
  }
};

/**
 * Check if a media is not empty.
 * @param {string} item
 */
export const mediaIsNotEmpty = item => {
  return !mediaIsEmpty(item);
};

/**
 * Get the font family from the page data.
 * @param {object} data
 */
export const getFontFamily = data => {
  if (data === null) return '';
  if (data.startsWith('google---')) return data.split('---')[1];
  return data;
};

/**
 * Get the icon url from the page data.
 * @param {string} path
 */
export const getIconUrl = path => {
  const item = get(path);

  if (item === null) return '';
  if (typeof item !== 'object') return '';
  if (!item.itemId) return '';

  const colors = Object.keys(item.colors).map(function (key, value) { return [key, value].join('='); }).join(',');
  return `${this.$store.state.page.domain}/icon/${item.itemId}?colors=${colors}`;
};
